interface StatusDotProps {
  tone: 'blue' | 'green' | 'amber' | 'gray';
  children: React.ReactNode;
}

export function StatusDot({ tone, children }: StatusDotProps) {
  return (
    <span className={`status-dot status-dot--${tone}`}>
      <span aria-hidden="true" />
      {children}
    </span>
  );
}

